import { OwnerFormData } from '@/schemas/ownerSchema'
import {
  BaseFilters,
  OwnerInsert,
  OwnerUpdate,
  OwnerWithPropertyCount,
} from '@/types'
import { UseMutateFunction } from '@tanstack/react-query'
import { createContext } from 'react'

export interface OwnersContextType {
  // State
  filters: BaseFilters
  data: OwnerWithPropertyCount[]
  totalPages: number
  currentPage: number
  isLoading: boolean
  isSendingVerification: boolean
  isCreating: boolean
  isUpdating: boolean
  isFormOpen: boolean
  isDeleteDialogOpen: boolean
  selectedOwner: OwnerWithPropertyCount | null
  ownerToDelete: OwnerWithPropertyCount | null
  error: Error | null
  count: number
  statistics: {
    averagePropertiesPerOwner: number
  }
  stats: {
    totalLinkedProperties: number
  }

  // Actions
  setFilters: React.Dispatch<React.SetStateAction<BaseFilters>>
  handleFormOpen: (owner?: OwnerWithPropertyCount) => void
  handleRowClick: (owner: OwnerWithPropertyCount) => void
  handleSendVerification: (ownerId: string) => void
  handleEdit: (owner: OwnerWithPropertyCount) => void
  handleDelete: (userId: string) => void
  handleFormSubmit: (formData: OwnerFormData) => void
  handleFormClose: () => void
  onDeleteDialogOpen: () => void
  onDeleteDialogClose: () => void
  handleCloseDeleteDialog: () => void
  handleConfirmDelete: () => void
  createOwner: UseMutateFunction<
    OwnerWithPropertyCount,
    Error,
    OwnerInsert,
    unknown
  >
  updateOwner: UseMutateFunction<
    OwnerWithPropertyCount,
    Error,
    {
      id: string | number
      data: OwnerUpdate
    },
    unknown
  >
  softDelete: (id: string) => void
  // restore: (id: string) => void
}

export const OwnersContext = createContext<OwnersContextType | undefined>(
  undefined
)
